import React from 'react';
import TextConstants from 'src/common/helpers/TextConstants';
import CommonConstants from './common/helpers/CommonConstants';

const Dashboard = React.lazy(() => import('./views/data/dashboard'));
const GPSDashboard = React.lazy(() => import('./views/data/gps-dashboard'));
const SensorDetail = React.lazy(() =>
  import('./views/data/gps-dashboard/SensorDetail')
);
const DataView = React.lazy(() => import('./views/data/data-view'));
const LastData = React.lazy(() => import('./views/data/last-data'));
const GatewaySettings = React.lazy(() =>
  import('./views/settings/gateway-settings')
);
const UnitSettings = React.lazy(() => import('./views/settings/unit-settings'));
const ChannelSettings = React.lazy(() =>
  import('./views/settings/channel-settings')
);
const UsersManagement = React.lazy(() => import('./views/users/general'));
const MZUsersManagement = React.lazy(() => import('./views/users/mz'));
const MZUserDetails = React.lazy(() =>
  import('./views/users/general/components/UserDetails')
);
// const GroupsManagement = React.lazy(() => import('./views/groups'));
const MZGroupsManagement = React.lazy(() => import('./views/groups/mz'));
// const GroupDevices = React.lazy(() => import('./views/groups/GroupDevices'));
const MZGroupDevices = React.lazy(() =>
  import('./views/groups/mz/GroupDevices')
);
const GroupStores = React.lazy(() => import('./views/groups/GroupStores'));

const StoresManagement = React.lazy(() => import('./views/stores'));

const ReceiversManagement = React.lazy(() => import('./views/receivers'));
const LoggersManagement = React.lazy(() => import('./views/loggers'));
const HistoryDataManagement = React.lazy(() => import('./views/history-data'));
const CSVDataManagement = React.lazy(() => import('./views/csv-data'));
const TrendGraphScreen = React.lazy(() => import('./views/trend-graph'));
// const MultiGraph = React.lazy(() => import('./views/multi-graph'));
const MissingData = React.lazy(() => import('./views/missing-data'));

const TermsOfService = React.lazy(() => import('./views/terms-of-service'));
const ApiKeysManagement = React.lazy(() => import('./views/api-keys'));
const HealthMonitorSettings = React.lazy(() =>
  import('./views/settings/health-monitor')
);
const AlarmEmailRoutingSettings = React.lazy(() =>
  import('./views/settings/alarm-email-routing')
);

const ROLE_CST = TextConstants.Common.RolesConst;
const routes = [
  {
    path: '/',
    exact: true,
    name: TextConstants.Common.Home,
    roles: [
      ROLE_CST.SUPER_ADMIN,
      ROLE_CST.COMPANY_ADMIN,
      ROLE_CST.DEVICE_ADMIN,
      ROLE_CST.STORE_ADMIN,
      ROLE_CST.GENERAL_USER,
    ],
    commodities: [
      CommonConstants.COMPANY_TYPE.GENERAL,
      CommonConstants.COMPANY_TYPE.MZ_MERCHANDISE,
    ],
  },
  // {
  //   path: '/dashboard',
  //   name: TextConstants.Dashboard.Title,
  //   component: Dashboard,
  //   roles: [
  //     ROLE_CST.COMPANY_ADMIN,
  //     ROLE_CST.DEVICE_ADMIN,
  //     ROLE_CST.STORE_ADMIN,
  //     ROLE_CST.GENERAL_USER,
  //   ],
  //   commodities: [
  //     CommonConstants.COMPANY_TYPE.GENERAL,
  //     CommonConstants.COMPANY_TYPE.MZ_MERCHANDISE,
  //   ],
  // },
  // {
  //   path: '/gps-dashboard',
  //   exact: true,
  //   name: TextConstants.GPSDashboard.Title,
  //   component: GPSDashboard,
  //   roles: [
  //     ROLE_CST.COMPANY_ADMIN,
  //     ROLE_CST.DEVICE_ADMIN,
  //     ROLE_CST.STORE_ADMIN,
  //     ROLE_CST.GENERAL_USER,
  //   ],
  // },
  // {
  //   path: '/gps-dashboard/sensor-details',
  //   exact: true,
  //   name: TextConstants.GPSDashboard.SensorMapDetail,
  //   component: SensorDetail,
  //   roles: [
  //     ROLE_CST.COMPANY_ADMIN,
  //     ROLE_CST.DEVICE_ADMIN,
  //     ROLE_CST.STORE_ADMIN,
  //     ROLE_CST.GENERAL_USER,
  //   ],
  //   commodities: [
  //     CommonConstants.COMPANY_TYPE.GENERAL,
  //     CommonConstants.COMPANY_TYPE.MZ_MERCHANDISE,
  //   ],
  // },
  // {
  //   path: '/data-view',
  //   name: TextConstants.DataView.Title,
  //   component: DataView,
  //   roles: [
  //     ROLE_CST.COMPANY_ADMIN,
  //     ROLE_CST.DEVICE_ADMIN,
  //     ROLE_CST.STORE_ADMIN,
  //     ROLE_CST.GENERAL_USER,
  //   ],
  //   commodities: [
  //     CommonConstants.COMPANY_TYPE.GENERAL,
  //     CommonConstants.COMPANY_TYPE.MZ_MERCHANDISE,
  //   ],
  // },
  // {
  //   path: '/last-data',
  //   name: TextConstants.LastData.Title,
  //   component: LastData,
  //   roles: [
  //     ROLE_CST.COMPANY_ADMIN,
  //     ROLE_CST.DEVICE_ADMIN,
  //     ROLE_CST.STORE_ADMIN,
  //     ROLE_CST.GENERAL_USER,
  //   ],
  //   commodities: [
  //     CommonConstants.COMPANY_TYPE.GENERAL,
  //     CommonConstants.COMPANY_TYPE.MZ_MERCHANDISE,
  //   ],
  // },
  // {
  //   path: '/gateway-settings',
  //   name: TextConstants.GatewaySettings.Title,
  //   component: GatewaySettings,
  //   roles: [ROLE_CST.COMPANY_ADMIN, ROLE_CST.DEVICE_ADMIN],
  //   commodities: [
  //     CommonConstants.COMPANY_TYPE.GENERAL,
  //     CommonConstants.COMPANY_TYPE.MZ_MERCHANDISE,
  //   ],
  // },
  // {
  //   path: '/device-settings',
  //   name: TextConstants.DeviceSettings.Title,
  //   component: UnitSettings,
  //   roles: [ROLE_CST.COMPANY_ADMIN, ROLE_CST.DEVICE_ADMIN],
  //   commodities: [
  //     CommonConstants.COMPANY_TYPE.GENERAL,
  //     CommonConstants.COMPANY_TYPE.MZ_MERCHANDISE,
  //   ],
  // },
  // {
  //   path: '/channel-settings',
  //   name: TextConstants.ChannelSettings.Title,
  //   component: ChannelSettings,
  //   roles: [ROLE_CST.COMPANY_ADMIN, ROLE_CST.DEVICE_ADMIN],
  //   commodities: [
  //     CommonConstants.COMPANY_TYPE.GENERAL,
  //     CommonConstants.COMPANY_TYPE.MZ_MERCHANDISE,
  //   ],
  // },
  {
    path: '/users',
    exact: true,
    name: TextConstants.UsersManagement.Title,
    component: UsersManagement,
    roles: [ROLE_CST.SUPER_ADMIN],
    commodities: [CommonConstants.COMPANY_TYPE.MZ_MERCHANDISE],
  },
  {
    path: '/api-keys',
    exact: true,
    name: TextConstants.ApiKeysManagement.Title,
    component: ApiKeysManagement,
    roles: [ROLE_CST.COMPANY_ADMIN],
    commodities: [CommonConstants.COMPANY_TYPE.MZ_MERCHANDISE],
    // Only Company Admin can manage API Keys (if apiKeysEnabled by SuperAdmin)
  },
  {
    path: '/users/:username',
    name: TextConstants.UsersManagement.UserDetails.Title,
    component: MZUserDetails,
    roles: [ROLE_CST.SUPER_ADMIN],
    commodities: [CommonConstants.COMPANY_TYPE.MZ_MERCHANDISE],
  },
  // {
  //   path: '/groups',
  //   exact: true,
  //   name: TextConstants.GroupsManagement.Title,
  //   component: GroupsManagement,
  //   roles: [ROLE_CST.COMPANY_ADMIN, ROLE_CST.DEVICE_ADMIN],
  // },
  // {
  //   path: '/groups/:groupId/devices',
  //   exact: true,
  //   name: TextConstants.GroupsManagement.GroupDevices.Title,
  //   component: GroupDevices,
  //   roles: [ROLE_CST.COMPANY_ADMIN, ROLE_CST.DEVICE_ADMIN],
  // },
  {
    path: '/stores',
    name: TextConstants.StoresManagement.Title,
    component: StoresManagement,
    roles: [ROLE_CST.COMPANY_ADMIN, ROLE_CST.DEVICE_ADMIN],
    commodities: [
      CommonConstants.COMPANY_TYPE.GENERAL,
      CommonConstants.COMPANY_TYPE.MZ_MERCHANDISE,
    ],
  },
  {
    path: '/receivers',
    name: TextConstants.ReceiversManagement.Title,
    component: ReceiversManagement,
    roles: [ROLE_CST.COMPANY_ADMIN, ROLE_CST.DEVICE_ADMIN],
    commodities: [CommonConstants.COMPANY_TYPE.MZ_MERCHANDISE],
  },
  {
    path: '/loggers',
    name: TextConstants.LoggersManagement.Title,
    component: LoggersManagement,
    roles: [
      ROLE_CST.COMPANY_ADMIN,
      ROLE_CST.DEVICE_ADMIN,
      ROLE_CST.STORE_ADMIN,
      ROLE_CST.GENERAL_USER,
    ],
    commodities: [CommonConstants.COMPANY_TYPE.MZ_MERCHANDISE],
  },
  {
    path: '/history-data',
    name: TextConstants.HistoryData.Title,
    component: HistoryDataManagement,
    roles: [ROLE_CST.COMPANY_ADMIN, ROLE_CST.DEVICE_ADMIN],
    commodities: [CommonConstants.COMPANY_TYPE.MZ_MERCHANDISE],
  },
  {
    path: '/csv-data',
    name: TextConstants.CSVData.Title,
    component: CSVDataManagement,
    roles: [
      ROLE_CST.COMPANY_ADMIN,
      ROLE_CST.DEVICE_ADMIN,
      ROLE_CST.STORE_ADMIN,
      ROLE_CST.GENERAL_USER,
    ],
    commodities: [CommonConstants.COMPANY_TYPE.MZ_MERCHANDISE],
  },
  {
    path: '/trend-graph',
    name: TextConstants.TrendGraph.Title,
    component: TrendGraphScreen,
    roles: [
      ROLE_CST.COMPANY_ADMIN,
      ROLE_CST.DEVICE_ADMIN,
      ROLE_CST.STORE_ADMIN,
      ROLE_CST.GENERAL_USER,
    ],
    commodities: [CommonConstants.COMPANY_TYPE.MZ_MERCHANDISE],
  },

  {
    path: '/health-monitor',
    name: TextConstants.HealthMonitor.Title,
    component: HealthMonitorSettings,
    roles: [ROLE_CST.COMPANY_ADMIN, ROLE_CST.DEVICE_ADMIN],
    commodities: [CommonConstants.COMPANY_TYPE.MZ_MERCHANDISE],
  },
  {
    path: '/alarm-email-routing',
    name: TextConstants.AlarmEmailRouting.Title,
    component: AlarmEmailRoutingSettings,
    roles: [ROLE_CST.COMPANY_ADMIN, ROLE_CST.DEVICE_ADMIN],
    commodities: [CommonConstants.COMPANY_TYPE.MZ_MERCHANDISE],
  },
  {
    path: '/mz-users',
    exact: true,
    name: TextConstants.UsersManagement.MZTitle,
    component: MZUsersManagement,
    roles: [
      ROLE_CST.COMPANY_ADMIN,
      ROLE_CST.DEVICE_ADMIN,
      ROLE_CST.STORE_ADMIN,
    ],
    commodities: [CommonConstants.COMPANY_TYPE.MZ_MERCHANDISE],
  },
  {
    path: '/mz-groups',
    exact: true,
    name: TextConstants.GroupsManagement.Title,
    component: MZGroupsManagement,
    roles: [ROLE_CST.COMPANY_ADMIN, ROLE_CST.DEVICE_ADMIN],
    commodities: [CommonConstants.COMPANY_TYPE.MZ_MERCHANDISE],
  },
  {
    path: '/mz-groups/:groupId/loggers',
    exact: true,
    name: TextConstants.GroupsManagement.GroupDevices.Title,
    component: MZGroupDevices,
    roles: [ROLE_CST.COMPANY_ADMIN, ROLE_CST.DEVICE_ADMIN],
    commodities: [CommonConstants.COMPANY_TYPE.MZ_MERCHANDISE],
  },
  {
    path: '/mz-groups/:groupId/stores',
    exact: true,
    name: TextConstants.GroupsManagement.GroupStores.Title,
    component: GroupStores,
    roles: [ROLE_CST.COMPANY_ADMIN, ROLE_CST.DEVICE_ADMIN],
    commodities: [CommonConstants.COMPANY_TYPE.MZ_MERCHANDISE],
  },
  // {
  //   path: '/multi-graph',
  //   name: TextConstants.MultiGraph.Title,
  //   component: MultiGraph,
  //   roles: [
  //     ROLE_CST.COMPANY_ADMIN,
  //     ROLE_CST.DEVICE_ADMIN,
  //     ROLE_CST.STORE_ADMIN,
  //     ROLE_CST.GENERAL_USER,
  //   ],
  // },
  // {
  //   path: '/missing-data',
  //   name: TextConstants.MissingData.Title,
  //   component: MissingData,
  //   roles: [ROLE_CST.COMPANY_ADMIN, ROLE_CST.DEVICE_ADMIN],
  // },
  {
    path: '/terms-of-service',
    name: TextConstants.Common.TermsOfService,
    component: TermsOfService,
    roles: [
      ROLE_CST.SUPER_ADMIN,
      ROLE_CST.COMPANY_ADMIN,
      ROLE_CST.DEVICE_ADMIN,
      ROLE_CST.STORE_ADMIN,
      ROLE_CST.GENERAL_USER,
    ],
    commodities: [
      CommonConstants.COMPANY_TYPE.GENERAL,
      CommonConstants.COMPANY_TYPE.MZ_MERCHANDISE,
    ],
  },
];

export default routes;
